import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';
import { textStyles } from '@/shared/tokens/typography';
import IconButton from '@/shared/ui/IconButton';
import { CloseIcon } from '@/shared/icons';

export interface ModalHeaderProps {
  title: string;
  onClose?: () => void;
  actions?: ReactNode;
  className?: string;
}

export default function ModalHeader({ title, onClose, actions, className }: ModalHeaderProps) {
  const { t } = useTranslation('common');

  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 border-b border-gray-300 px-4 py-3 sm:px-6',
        className,
      )}
    >
      <h2 id="modal-title" className={textStyles.sectionTitle}>
        {title}
      </h2>
      <div className="flex items-center gap-2">
        {actions}
        {onClose ? (
          <IconButton ariaLabel={t('close')} onClick={onClose}>
            <CloseIcon className="h-5 w-5 text-gray-500" />
          </IconButton>
        ) : null}
      </div>
    </div>
  );
}
